import React, { useState } from "react";
import { AddContainer } from "./style";
import { Link } from "react-router-dom";
import { CREATE_DATA_PETTY_CASHIER } from "../../../../constants/urls";
import { getPanel } from "../../../../assets/selectProjectUserOrPanel";
import { NON_CUSTODIAN_PANEL } from "../../../../constants/panelTypes";
import Variables from "../../../../assets/styleVariables";
import {
  CUSTODIAN_MAIN_COLOR,
  MANAGER_MAIN_COLOR
} from "../../../../constants/theme";

export const Add = props => {
  const [active] = useState(false);
  const isManagerPanel = getPanel() === NON_CUSTODIAN_PANEL;
  return (
    <AddContainer
      status={active}
      hasShadow={props.hasShadow}
      expand={props.expand}
      color={isManagerPanel ? MANAGER_MAIN_COLOR : CUSTODIAN_MAIN_COLOR}
    >
      <Link className={`add-button`} title="ثبت اطلاعات" to={props.route}>
        <div className="button-text">
          <i className="icon mapsa-plus"> </i>
          <span className="add-button-text no-select">
            {props.route === CREATE_DATA_PETTY_CASHIER
              ? "ثبت اطلاعات"
              : "عملیات جدید"}
          </span>
        </div>
      </Link>
    </AddContainer>
  );
};
